import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { Event } from '../model/event';
import { EventsService } from '../service/events.service';
import { NavbarService } from '../service/navbar.service';

// Resolver pra rota `/{slug}` — descobre o evento pelo slug (event.uri)
// e injeta no `route.data.event`. Se o slug não casar com nenhum evento,
// redireciona pra 404. `EventViewComponent` lê `data.event` antes de
// cair no fluxo legado de `params.id`.
//
// O resolver também aciona a progress bar do topo (`navbarService.loadingStart`)
// porque ele roda ANTES do `ngOnInit` do EventViewComponent — se a flag for
// ligada só lá, o debounce de 300ms no NavbarService consome o evento (a
// request HTTP já completou antes do timer disparar). Aqui ela inicia
// junto da request e para no `finalize`, cobrindo todo o tempo de espera.
@Injectable({ providedIn: 'root' })
export class EventBySlugResolver implements Resolve<Event | null> {
  constructor(
    private eventsService: EventsService,
    private router: Router,
    private navbarService: NavbarService,
  ) {}

  resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<Event | null> {
    const slug = route.paramMap.get('slug');
    if (!slug) {
      this.router.navigate(['/error/404']);
      return of(null);
    }
    this.navbarService.loadingStart();
    return this.eventsService.getEventByLink(slug).pipe(
      catchError(() => {
        this.router.navigate(['/error/404']);
        return of(null);
      }),
      finalize(() => this.navbarService.loadingStop()),
    );
  }
}
